import { Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { HelpTicket } from '@shared/models/help-ticket.model';
import { SortEvent } from '@shared/models/sort-event';
import { DeleteEvent } from '../ticket-list.component';

@Component({
  /* tslint:disable */
  // selector required as an attribute since table nature.
  selector: '[miq-ticket-row]',
  /* tslint:enable */
  templateUrl: './ticket-row.component.html',
  styleUrls: ['./ticket-row.component.scss'],
  standalone: false,
})
export class TicketRowComponent {
  @Input()
  public row: HelpTicket;
  @Input()
  public index: number;
  @Input()
  public sortEvent: SortEvent;
  @Input()
  public isProfile = false;
  @Input()
  public isInGroup = false;
  @Input()
  public isFolder = false;

  @Output()
  public deleteTicketEmitter: EventEmitter<DeleteEvent>;
  @Output()
  public checked: EventEmitter<HelpTicket | number>;
  @Output()
  public unchecked: EventEmitter<number>;
  @Output()
  public menuClick: EventEmitter<{ ticket: HelpTicket; mouseEvent: MouseEvent }>;
  @Output()
  public showTicketDetailEvent: EventEmitter<{ ticketId: number; isInGroup: boolean }>;

  public isExpanded = false;

  constructor(public element: ElementRef) {
    this.deleteTicketEmitter = new EventEmitter();
    this.checked = new EventEmitter();
    this.unchecked = new EventEmitter();
    this.menuClick = new EventEmitter();
    this.showTicketDetailEvent = new EventEmitter();
  }

  public getAssignedToShortNames() {
    const { assignedTo } = this.row;
    return assignedTo.length > 1 ? `${assignedTo[0].value} +${assignedTo.length - 1}` : assignedTo[0].value;
  }

  public getAssignedToNames() {
    const { assignedTo } = this.row;
    return assignedTo.length > 1 ? `${assignedTo.map(({ value }) => value).join('\n')}` : assignedTo[0].value;
  }

  public onCkboxToggle(checked: boolean) {
    if (checked) {
      this.onCheck(this.row, this.index);
    } else {
      this.onUncheck(this.row);
    }
  }

  public deleteTicket(index: number, ticketId: number) {
    this.deleteTicketEmitter.emit({ index, ticketId });
  }

  public toggleMenu(mouseEvent: MouseEvent) {
    this.menuClick.emit({ ticket: this.row, mouseEvent });
  }

  public onExpand() {
    this.isExpanded = this.isExpanded ? false : true;
  }

  public showTicketDetails(ticketId: number, isInGroup: boolean) {
    this.showTicketDetailEvent.emit({ ticketId, isInGroup });
  }

  private onCheck(selectedTicket: HelpTicket, ticketIndex: number) {
    selectedTicket.checked = true;
    this.checked.emit(ticketIndex);
  }

  private onUncheck(selectedTicket: HelpTicket) {
    selectedTicket.checked = false;
    this.unchecked.emit(selectedTicket.priority);
  }
}
